import { render, staticRenderFns } from "./QuestionsList.vue?vue&type=template&id=6c71292e&scoped=true&"
import script from "./QuestionsList.vue?vue&type=script&lang=js&"
export * from "./QuestionsList.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsList.vue?vue&type=style&index=0&id=6c71292e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71292e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VProgressLinear,VRow})
